import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import TaskCard from './TaskCard';

const SortableTask = ({ task, columnId, onTaskClick }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: task.id,
    data: {
      type: 'task',
      task,
      columnId,
    },
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 999 : 'auto',
  };

  const handleTaskClick = taskOrEvent => {
    if (isDragging) return;

    // console.log('🎯 SortableTask: handleTaskClick called with:', taskOrEvent);
    // console.log('Is it an event?', taskOrEvent && (taskOrEvent._reactName || taskOrEvent.nativeEvent || taskOrEvent.type === 'click'));

    if (taskOrEvent && (taskOrEvent._reactName || taskOrEvent.nativeEvent || taskOrEvent.type === 'click')) {
      // console.log('⚠️ SortableTask: Received event object, ignoring and using task instead');
      if (onTaskClick && typeof onTaskClick === 'function') {
        // console.log('✅ SortableTask: Calling onTaskClick with original task:', task);
        onTaskClick(task);
      }
      return;
    }

    const finalTask = taskOrEvent || task;
    // console.log('🎯 SortableTask: Using final task:', finalTask);

    if (onTaskClick && typeof onTaskClick === 'function') {
      // console.log('✅ SortableTask: Calling onTaskClick with final task:', finalTask);
      onTaskClick(finalTask);
    } else {
      console.error('❌ SortableTask: onTaskClick is not a function');
    }
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <TaskCard task={task} isDragging={isDragging} onClick={handleTaskClick} />
    </div>
  );
};

export default SortableTask;